import { ReactNode } from 'react';

import { Column, SortOrder } from './SortableHeader';

export enum RowsPerPage {
  ONE = 1,
  TWENTYFIVE = 25,
  FIFTY = 50,
  HUNDRED = 100
}

export const DefaultRowsPersPage = RowsPerPage.TWENTYFIVE;

export interface TableListProps<T> {
  data: T[];
  columns: Column<T>[];
  page?: number;
  rowsPerPage?: RowsPerPage;
  /**
   * defaultSortKey: by default `id` will be used to sort data initially. If T has no `id`, you can set your own key instead
   */
  defaultSortKey?: keyof T;
  /**
   * defaultSortOrder: by default DESC order will be used to sort data initially.
   */
  defaultSortOrder?: SortOrder;

  onPaginationChange?: (page: number, rowsPerPage: number) => void;
  /**
   * empty: what to display when data.length === 0
   */
  empty?: ReactNode;
  /**
   * action: what a row action will be rendered
   */
  action?: (row: T) => ReactNode;
  /**
   * children: to be rendered as fitlering section
   */
  children?: ReactNode | ReactNode[];
  /**
   * expandFilter: to toggle the expansion of filtering section
   */
  expandFilters?: boolean;
  /**
   * loading: if loading bar should show
   */
  loading?: boolean;
  /**
   * total: total number of records
   */
  total: number;
  /**
   * overflowX: whether the overflowX should be auto or visible
   */
  overflowXVisible?: boolean;
}
